import React from "react";

export default function ForumCard ({information}) {

    return (
        <div>
            <div>Id</div>
            <div>Context</div>
        </div>
    );
}